
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useState, useEffect } from 'react';

export default function Hero() {
  const contentAnimation = useScrollAnimation({ threshold: 0.2 });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    'https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/14f72c7da54ab8b489267989125bccbe.jpeg',
    'https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/f71c84c9998897b2d299f8f642379d60.jpeg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="relative h-[60vh] sm:h-[70vh] md:h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`Hero Background ${index + 1}`}
              className="w-full h-full object-cover object-center sm:object-cover animate-hero-zoom"
            />
          </div>
        ))}
        
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      <div 
        ref={contentAnimation.ref as React.RefObject<HTMLDivElement>}
        className={`relative z-10 text-white px-4 sm:px-6 max-w-5xl mx-auto scroll-animate ${contentAnimation.isVisible ? 'is-visible' : ''}`}
      >
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-center">
          電気で、未来を照らす。
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-normal leading-relaxed opacity-90 text-left">
          私たちは電気設備工事を通じて、安全で快適な環境づくりを支えます。
        </p>
      </div>
    </section>
  );
}
